var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@naturehouse/design-system/components/molecules/toggle-icon-button/ToggleIconButton.html.njk"] = require( "@naturehouse/design-system/components/molecules/toggle-icon-button/ToggleIconButton.html.njk" );




var shim = require("/builds/natuurhuisje/nature.house/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/components/molecules/favoriteButton.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["house", "is_favorite"], 
[], 
function (l_house, l_is_favorite, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("house", l_house);
frame.set("is_favorite", l_is_favorite);
var t_2 = "";t_2 += "\n    <div class=\"favorite-add-button\">\n        ";
var t_3;
t_3 = {"name": "heart"};
frame.set("defaultIcon", t_3, true);
if(frame.topLevel) {
context.setVariable("defaultIcon", t_3);
}
if(frame.topLevel) {
context.addExport("defaultIcon", t_3);
}
t_2 += "\n        ";
var t_4;
t_4 = {"name": "heart-filled"};
frame.set("activeIcon", t_4, true);
if(frame.topLevel) {
context.setVariable("activeIcon", t_4);
}
if(frame.topLevel) {
context.addExport("activeIcon", t_4);
}
t_2 += "\n\n        ";
var t_5;
t_5 = "nh-add-favorite";
frame.set("toggleIconButtonClass", t_5, true);
if(frame.topLevel) {
context.setVariable("toggleIconButtonClass", t_5);
}
if(frame.topLevel) {
context.addExport("toggleIconButtonClass", t_5);
}
t_2 += "\n        ";
var t_6;
t_6 = ["favorite-add-button__button"];
frame.set("classes", t_6, true);
if(frame.topLevel) {
context.setVariable("classes", t_6);
}
if(frame.topLevel) {
context.addExport("classes", t_6);
}
t_2 += "\n\n        ";
var t_7;
t_7 = {"endpoint": "/favorite/" + "" + runtime.memberLookup((l_house),"id"),"data-role": "favoriteButton","data-testid": "favorite-button","data-meta": env.getFilter("json_encode").call(context, {"id": runtime.memberLookup((l_house),"id")})};
frame.set("data", t_7, true);
if(frame.topLevel) {
context.setVariable("data", t_7);
}
if(frame.topLevel) {
context.addExport("data", t_7);
}
t_2 += "\n\n        ";
var t_8;
t_8 = l_is_favorite;
frame.set("active", t_8, true);
if(frame.topLevel) {
context.setVariable("active", t_8);
}
if(frame.topLevel) {
context.addExport("active", t_8);
}
t_2 += "\n        ";
if(l_is_favorite) {
t_2 += "\n            ";
var t_9;
t_9 = env.getFilter("merge").call(context, runtime.contextOrFrameLookup(context, frame, "data"),{"favorited": "true"});
frame.set("data", t_9, true);
if(frame.topLevel) {
context.setVariable("data", t_9);
}
if(frame.topLevel) {
context.addExport("data", t_9);
}
t_2 += "\n        ";
;
}
t_2 += "\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("@naturehouse/design-system/components/molecules/toggle-icon-button/ToggleIconButton.html.njk", false, "templates/components/molecules/favoriteButton.html.njk", false, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
callback(null,t_10);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
callback(null,t_12);});
});
tasks.push(
function(result, callback){
t_2 += result;
callback(null);
});
env.waterfall(tasks, function(){
t_2 += "\n    </div>\n";
});
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("render");
context.setVariable("render", macro_t_1);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/components/molecules/favoriteButton.html.njk"] , dependencies)